const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the single comment component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {MainComments} MainComments the resource defined to manage MainComments
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 */
app.directive('singleComment', ['Application', 'Authorization', 'MainComments', 'Users', 'Analyze', '$translate', '$filter', function (Application, Authorization, MainComments, Users, Analyze, $translate, $filter) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      comment: '=',
      isReply: '@',
      parent: '=',
      replyTo: '&',
      showChild: '=',
      contentDirectory: '=',
      hideMain: '=',
      isSingle: '=',
      linkedReply: '='
    },
    template: require('../../templates/directives/single-comment.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.isAdmin = self.user.role && self.user.role === 'admin' ? true : false;
      var currentUser = Authorization.getAuthToken().user._id;
      self.settings = {
        title: '',
        contentId: '',
        contentType: '',
        secondaryId: null,
        secondaryType: null,
        linkedReply: false,
        findCommentType: function(secondary) {
          if (!secondary && $scope.comment.track) {
            return 'track';
          }
          var type = $scope.comment.video ? 'video' : $scope.comment.file ? 'file' : $scope.comment.article ? 'article' : $scope.comment.quiz ? 'quiz' : $scope.comment.event ? 'event' : $scope.comment.media ? 'media' : $scope.comment.workshop ? 'workshop' : $scope.comment.imported_content ? 'imported_content' : $scope.comment.scorm ? 'scorm' : null;
          return type;
        }
      };

      self.translateDate = function(date) {
        if (date === 'a few seconds ago'){
          return self.translations['singlecomment.aFewSecondsAgo'];
        } else {
          return date;
        };
      };

      self.snipTitle = function(title) {
        return $filter('commentTitleSnip')(title);
      };

      self.checkName = function(name) {
        if(name){
          return name;
        } else {
          return self.translations['singlecomment.anonymous'];
        };
      };

      self.setInitial = function() {
        self.settings.contentId = $scope.comment._id;
        self.settings.contentType = self.settings.findCommentType();
        if (!self.settings.contentType || !$scope.comment[self.settings.contentType]) {
          console.log('error - no type found');
          return;
        }
        self.settings.linkedReply = $scope.linkedReply && self.settings.contentId === $scope.linkedReply ? true : false;

        // This will maintain the secondary type for track context
        if (self.settings.contentType === 'track') {
          self.settings.secondaryType = self.settings.findCommentType(true);
          if (self.settings.secondaryType && $scope.comment[self.settings.secondaryType]) {
            if (self.settings.secondaryType === 'video' || self.settings.secondaryType === 'file') {
              self.settings.secondaryId = $scope.comment[self.settings.secondaryType];
              self.settings.secondaryType = 'media';
            } else {
              self.settings.secondaryId = $scope.comment[self.settings.secondaryType];
            }
          }
        }

        if ($scope.comment.removed) {
          $scope.comment.mentions = [];
          $scope.comment.likes = [];
          $scope.comment.editable = false;
          $scope.comment.user = {};
          self.replies.children = $scope.comment.children || [];
          self.replies.initialize();
          return;
        }
        if ($scope.comment.user && $scope.comment.user._id && $scope.comment.user._id.toString() === currentUser.toString()) {
          $scope.comment.editable = true;
        }
        $scope.comment.likes = $scope.comment.likes ? $scope.comment.likes : [];
        self.reactions.userLiked = $scope.comment.likes && $scope.comment.likes.indexOf(currentUser.toString()) > -1 ? true : false;
        self.reactions.setAdditional();
        $scope.comment.date = moment($scope.comment.createdAt).fromNow();
        self.replies.children = $scope.comment.children || [];
        self.replies.initialize();
      };

      self.reply = {
        active: false,
        focus: false,
        comment: '',
        mentions: [],
        submission: false,
        showSubmit: false,
        postLoading: false,
        cancel: false,
        cancelReply: function() {
          this.cancel = true;
          this.active = false;
          $scope.hideMain = false;
        },
        activate: function(user) {
          if (this.active) {
            Application.messaging.addMessage({type: 'information', duration: 5, text: self.translations['singlecomment.cancelOrConfirm']});
            return;
          }
          self.reply.comment = '';
          self.reply.mentions = [];
          self.reply.focus = true;
          if (user) {
            setTimeout(function() {
              self.reply.comment = '<:' + user.first_name + '.' + user.last_name + ':' + user._id + '>';
              self.reply.mentions = [user._id];
              self.reply.active = true;
              $scope.hideMain = true;
              $scope.$apply();
            }, 10);
            return;
          }
          if ($scope.isReply) {
            $scope.replyTo({user: $scope.comment.user});
            return;
          }
          setTimeout(function() {
            self.reply.comment = '';
            self.reply.mentions = [];
            self.reply.active = true;
            $scope.hideMain = true;
            $scope.$apply();
          }, 10);
        },
        submit: function() {
          this.submission = true;
          // timeout is needed to allow the digest cycle
          setTimeout(function() {
            self.reply.postComment();
          }, 10)
        },
        postComment: function() {
          self.reply.postLoading = true;
          self.reply.testSubmit = true;
          // Perform post
          var item = {
            comment: this.comment,
            mentions: this.mentions || [],
            user: currentUser,
            liked: [],
            is_reply: true,
            children: []
          };

          if (self.settings.secondaryType && self.settings.secondaryId) {
            item[self.settings.secondaryType] = self.settings.secondaryId;
          }

          MainComments.create({
            fields: 'comment,media,track,article,evnt,user,workshop,quiz,createdAt,is_reply',
            type: self.settings.contentType,
            contentId: $scope.comment[self.settings.contentType],
            parent: $scope.comment._id
          }, item, function(data) {
            data.user = Authorization.getAuthToken().user;
            self.reply.comment = '';
            self.reply.mentions = [];
            self.reply.postLoading = false;
            self.reply.active = false;
            $scope.hideMain = false;
            self.replies.list.push(data);
            if (self.settings.contentType) {
              Analyze.record({resource: 'comments'}, {content: $scope.comment[self.settings.contentType], content_type: self.settings.contentType});
              Application.analyticsProvider.trackEvent(self.settings.contentType + '_commented', {content: $scope.comment[self.settings.contentType], content_type: self.settings.contentType});
            }
          }, function(err) {
            console.log('Error occured creating comment ', err);
            self.postLoading = false;
          });
        }
      };

      self.replies = {
        per_page: 3,
        seeMore: $scope.comment.children ? $scope.comment.children.length : 0,
        children: [],
        list: [],
        getMore: function() {
          var toGet = this.children.splice(-1 * this.per_page);
          if (!toGet.length) {
            return;
          }
          this.seeMore = this.children.length;
          MainComments.find({
            _id: '$in,' + toGet.length + ',' + toGet.join(','),
            fields: 'comment,media,track,article,evnt,quiz,workshop,user,edited,createdAt,mentions,likes,removed,is_reply',
            'user-populate': 'first_name,last_name,email,image,job_title'
          }).$promise.then(function(comments) {
            self.replies.list = self.replies.list.concat(comments);
          }).catch(function(error) {
            console.log('error retrieving child comments');
          });
        },
        initialize: function() {
          if (!this.children || !this.children.length) {
            return;
          }

          var toGet = 0;
          var limit = $scope.isSingle ? 5 : 3;

          if (this.children.length > limit) {
            toGet = this.children.length - limit;
          }

          toGet = this.children.splice(toGet);

          this.seeMore = this.children.length;
          MainComments.find({
            _id: '$in,' + toGet.length + ',' + toGet.join(','),
            fields: 'comment,media,track,article,evnt,quiz,workshop,user,edited,createdAt,mentions,likes,removed,is_reply',
            'user-populate': 'first_name,last_name,email,image,job_title'
          }).$promise.then(function(comments) {
            self.replies.list = self.replies.list.concat(comments);
          }).catch(function(error) {
            console.log('error retrieving child comments');
          });
        }
      };

      self.edit = {
        active: false,
        focus: false,
        loading: false,
        originalComment: null,
        originalMentions: null,
        comment: null,
        mentions: null,
        submission: false,
        allowSubmit: false,
        start: function() {
          this.originalComment = $scope.comment.comment && $scope.comment.comment.length ? $scope.comment.comment.slice(0) : '';
          this.originalMentions = $scope.comment.mentions && $scope.comment.mentions.length ? $scope.comment.mentions.slice(0) : [];
          this.comment = '';
          this.mentions = [];
          // this is needed to continuously trigger the mention $watch
          setTimeout(function() {
            self.edit.comment = $scope.comment.comment && $scope.comment.comment.length ? $scope.comment.comment.slice(0) : '';
            self.edit.mentions = $scope.comment.mentions && $scope.comment.mentions.length ? $scope.comment.mentions.slice(0) : [];
            self.edit.active = true;
            self.edit.focus = true;
            $scope.$apply();
          }, 10)
        },
        cancel: function() {
          $scope.comment.comment = this.originalComment;
          $scope.comment.mentions = this.originalMentions;
          this.active = false;
        },
        submit: function() {
          if (!this.allowSubmit) {
            this.cancel();
            return;
          }
          this.loading = true;
          this.submission = true;
          // timeout is needed to allow the digest cycle
          setTimeout(function() {
            self.edit.postEdit();
          }, 10)
        },
        postEdit: function() {
          var item = {
            comment: this.comment,
            mentions: this.mentions || [],
            edited: true,
            user: $scope.comment.user,
            hasParent: $scope.isReply ? $scope.parent : null
          };

          MainComments.update({
            subresource: $scope.comment._id,
            fields: 'comment,media,track,article,quiz,evnt,workshop,user,edited,createdAt'
          }, item, function(data) {
            $scope.comment.editable = true;
            $scope.comment.edited = true;
            $scope.comment.comment = data.comment;
            $scope.comment.mentions = data.mentions;
            self.edit.loading = false;
            self.edit.active = false;
            Application.messaging.addMessage({type: 'success', duration: 3, text: self.translations['singlecomment.editSaved']});
          }, function(err) {
            self.edit.loading = false;
            self.edit.active = false;
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['singlecomment.issueSavingEdit']});
          });
        }
      };

      self.reactions = {
        userLiked: false,
        list: [],
        loading: false,
        populated: false,
        additional: 0,
        react: function() {
          var originalState = this.userLiked;
          var action = originalState ? 'unlike' : 'like';
          MainComments[action]({subresource: $scope.comment._id, userid: currentUser}, {parent: $scope.parent || null}).$promise
          .then(function(comment) {
            $scope.comment.likes = comment.likes;
            self.setInitial();
          });
        },
        hovered: function() {
          if (this.populated) {
            return;
          }
          this.loading = true;
          this.populated = true;
          var ids = [];
          for (var i = 0; i < $scope.comment.likes.length; i++) {
            if ($scope.comment.likes[i].toString() !== currentUser.toString()) {
              ids.push($scope.comment.likes[i]);
              if (ids.length === 3) {
                break;
              }
            }
          }
          if (!ids.length) {
            this.loading = false;
            return;
          }
          Users.find({
            _id: '$in,' + ids.length + ',' + ids.join(','),
            fields: 'email,first_name,last_name,full_name'
          }).$promise.then(function(users) {
            self.reactions.list = users;
            self.reactions.setAdditional();
            self.reactions.loading = false;
          });
        },
        setAdditional: function() {
          self.reactions.additional = $scope.comment.likes && $scope.comment.likes.length ? $scope.comment.likes.length - self.reactions.list.length : 0;
          if (self.reactions.userLiked) {
            self.reactions.additional--;
          }
        }
      };

      self.deleteComment = function() {
        MainComments.remove({
          subresource: $scope.comment._id
        }, function(data) {
          $scope.comment.comment = data.comment;
          $scope.comment.removed = true;
          $scope.comment.user = {};
          self.setInitial();
        }, function(err) {
          console.log('Error occured removing comment ', err);
        });
      };

      $translate([
        'singlecomment.cancelOrConfirm',  
        'singlecomment.editSaved',  
        'singlecomment.issueSavingEdit',  
        'singlecomment.unableToRemove',
        'singlecomment.aFewSecondsAgo',
        'singlecomment.anonymous'
      ]).then(function(translations){
        self.translations = translations;
        self.setInitial();
      });

    }],
    controllerAs: 'single'
  };
}]);